import React from 'react';
import './Hero.css';

function Hero() {
  return (
    <section id="home" className="hero">
      <div className="container hero-content">
        <div className="hero-text">
          <h1 className="hero-title">
            Elevate Your Business with
            <span className="gradient-text"> CodersPing</span>
          </h1>
          <p className="hero-subtitle">
            Expert Software Development, Consultancy, and Premium Staffing Solutions
          </p>
          <div className="hero-buttons">
            <a href="#services" className="btn btn-primary">Our Services</a>
            <a href="#contact" className="btn btn-secondary">Get Started</a>
          </div>
        </div>
        <div className="hero-visual">
          <div className="floating-card card-1">
            <div className="card-icon">💻</div>
            <h3>Development</h3>
          </div>
          <div className="floating-card card-2">
            <div className="card-icon">🎯</div>
            <h3>Consultancy</h3>
          </div>
          <div className="floating-card card-3">
            <div className="card-icon">👥</div>
            <h3>Staffing</h3>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
